module.exports = __webpack_public_path__ + "img/apk.428101ff.png";